import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=19607a8e&scoped=true&"
import script from "./WeChat.vue?vue&type=script&lang=js&"
export * from "./WeChat.vue?vue&type=script&lang=js&"
import style0 from "./WeChat.vue?vue&type=style&index=0&id=19607a8e&lang=scss&scoped=true&"
import style1 from "./WeChat.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19607a8e",
  null
  
)

export default component.exports